import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import type { ForwardedRef } from 'react';
import { Form } from 'react-bootstrap';

type Props = {
  value?: string | number;
  id?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  className?: string;
  validationError: string;
};

export type FocusableInputRef = {
  focus: () => void;
};

function FocusableInput(
  { id, onChange, onClick, onKeyDown, placeholder, type, className, validationError }: Props,
  ref: ForwardedRef<FocusableInputRef>
) {
  const inputRef = useRef<HTMLInputElement>(null);
  useImperativeHandle(ref, () => ({
    focus: () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    },
  }));

  return (
    <Form.Control
      placeholder={placeholder}
      onChange={onChange}
      onClick={onClick}
      onKeyDown={onKeyDown}
      id={id}
      ref={inputRef}
      type={type}
      className={className}
      isInvalid={!!validationError}
    />
  );
}

const refForwarded = forwardRef<FocusableInputRef, Props>(FocusableInput);

export { refForwarded as FocusableInput };
